import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

export default class LocationSelect extends Component {
  static propTypes = {
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedId: PropTypes.number,
    onChange: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = { locationsAsOptions: this.populateOptions() }
    this.state.placeholder = this.populatePlaceholder()
  }

  populateOptions () {
    const locationsAsOptions = [{ label: 'All', value: null }]
    for (var i = this.props.locations.length - 1; i >= 0; i--) {
      locationsAsOptions.push({
        label: this.props.locations[i].name,
        value: this.props.locations[i],
      })
    }
    return locationsAsOptions
  }

  populatePlaceholder () {
    let selected = null

    if (this.props.selectedId) {
      selected = this.state.locationsAsOptions.find((option) => {
        return option.value && this.props.selectedId === option.value.id
      })
    }

    return selected?.label || 'All'
  }

  onChange (option) {
    this.setState({ placeholder: option.label })
    if (this.props.onChange) {
      this.props.onChange(option.value)
    }
  }

  render () {
    return (
      <Select
        className="schedule_location_select"
        searchable={false}
        clearable={false}
        name="location"
        placeholder={this.state.placeholder}
        options={this.state.locationsAsOptions}
        onChange={this.onChange.bind(this)}
        aria-label="Location Select"
      />
    )
  }
}
